import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import AgeAnalysisLiabilityCriteria from "./AgeAnalysisLiabilityCriteria";
import { ReportCategory } from "../ReportCategory";
import { Neo } from "@singularsystems/neo-react";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";

@NeoReport("AgeAnalysisLiabilityReport", { category: ReportCategory.InvestorReports })
export default class AgeAnalysisLiabilityReport extends Report<AgeAnalysisLiabilityCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(AgeAnalysisLiabilityCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.FormGroupInline bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
        </div>;
    }
}